import { AD, HIGHLIGHT, MOVIE, NEWSLETTER_IMAGE, NEWSLETTER_TEXT } from '../../../constants/itemTypes'
import ListItemWithMovieContainer from '../../DragAndDropItems/cont/ListItemWithMovieContainer'
import config from '../../../config.json'
import ListItemMovieContainer from '../../DragAndDropItems/cont/ListItemMovieContainer'
import ListItemTextContainer from '../../DragAndDropItems/cont/ListItemTextContainer'
import ListItemImageContainer from '../../DragAndDropItems/cont/ListItemImageContainer'
import ListItemNoDataContainer from '../../DragAndDropItems/cont/ListItemNoDataContainer'

const NewsletterDragDropItemSwitch = ({
    itemId,
    itemType, 
    itemData, 
    additionalClass=false,
    params,
    isSelected = false,
    canEdit = false, 
    canDelete = false, 
    deleteItem = false,
}) => {
    const pathnameEdit = canEdit ? `${config.routes.newsletter.path}/campaign/${params.campaignId}/${itemType}/${itemId}/edit-item` : false
    const onDeleteItem = canDelete ? () => deleteItem(itemId, itemType) : false

    return (
        !itemData ? (
            <ListItemNoDataContainer />
        ) : (AD === itemType || HIGHLIGHT === itemType)  ? (
            <ListItemWithMovieContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />
        ) : MOVIE === itemType ? (
            <ListItemMovieContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />
        ) : NEWSLETTER_TEXT === itemType ? (
            <ListItemTextContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />

        ) : NEWSLETTER_IMAGE === itemType ? (
            <ListItemImageContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />
        ) : ''
    )
}

export default NewsletterDragDropItemSwitch